import React from 'react';
import {styled} from '@mui/material/styles';
import MaterialTooltip from '@mui/material/Tooltip';
import type {TooltipProps as MaterialTooltipProps} from '@mui/material/Tooltip';

export type TooltipProps = Omit<MaterialTooltipProps, 'arrow' | 'TransitionComponent' >;

const StyledTooltip = styled(({
    className, classes, ...props
}: TooltipProps) => (
    <MaterialTooltip
        {...props}
        arrow
        classes={{
            popper: className,
            ...classes
        }}
    />
))(({theme}) => ({
    '& .MuiTooltip-tooltip': {
        backgroundColor: theme.tokens.FuelColorGray900,
        boxShadow: theme.tokens.FuelShadowXl,
        fontSize: theme.tokens.FuelFontSizeXs,
        fontWeight: theme.tokens.FuelFontWeightRegular
    },
    '& .MuiTooltip-arrow': {
        color: theme.tokens.FuelColorGray900
    }
}));

export const Tooltip = React.forwardRef<any, TooltipProps>(
    (props, ref) => (
        <StyledTooltip
            ref={ref}
            {...props}
        />
    ));

Tooltip.displayName = 'Tooltip';
